import { Container as ChakraContainer } from "@chakra-ui/react";
import type { ComponentPropsWithRef } from "react";

export type ContainerProps = ComponentPropsWithRef<typeof ChakraContainer>;

export function Container(props: ContainerProps) {
  return <ChakraContainer {...props} />;
}
